import { cn } from '@bem-react/classname'
import {
  DetailedHTMLProps,
  FC,
  InputHTMLAttributes,
  useCallback,
  useEffect,
  useState,
} from 'react'
import { Transition } from 'react-transition-group'
import { useTranslation } from 'react-i18next'

import { Memo } from '@/hoc/Memo'
import { getItem, setItem } from '@/utils/persistanceStorage'
import { languages } from './data'
import { LanguageModel } from './LanguageModel'

import './Language.scss'

const cnLanguage = cn('Language')

interface LanguageSchema
  extends DetailedHTMLProps<
    InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {}

export const Language: FC<LanguageSchema> = Memo(
  ({ className }: LanguageSchema) => {
    const [open, setOpen] = useState(false)
    const [currentLanguage, setCurrentLanguage] = useState<LanguageModel>(
      new LanguageModel(),
    )
    const { i18n } = useTranslation()

    const getCurrentLanguage = (langId: string) => {
      const current = languages.find(language => language.langId === langId)

      if (current) setCurrentLanguage(current)
    }

    const changeLang = useCallback(
      async (langId: string) => {
        i18n.changeLanguage(langId)
        setOpen(false)
        getCurrentLanguage(langId)
        setItem('lang', langId, false)
      },
      [i18n],
    )

    useEffect(() => {
      const lang = getItem('lang', false)

      if (lang) {
        i18n.changeLanguage(lang)
        getCurrentLanguage(lang)
      } else {
        getCurrentLanguage('en-GB')
        i18n.changeLanguage('en-GB')
      }
    }, [i18n])

    return (
      <div className={cnLanguage(null, [className])}>
        <button
          type='button'
          className={cnLanguage('current')}
          onClick={() => setOpen(!open)}
        >
          {currentLanguage.flag && (
            <img src={currentLanguage.flag} alt={currentLanguage.title} />
          )}
        </button>

        <Transition timeout={250} in={open} unmountOnExit mountOnEnter>
          {state => (
            <div
              className={cnLanguage('list', [state])}
              onMouseLeave={() => setOpen(false)}
            >
              {languages &&
                languages.map(language => (
                  <button
                    key={language.langId}
                    type='button'
                    className={cnLanguage('item')}
                    onClick={() => {
                      changeLang(language.langId)
                    }}
                  >
                    <img src={language.flag} alt={language.title} />
                    <div className={cnLanguage('text')}>{language.title}</div>
                  </button>
                ))}
            </div>
          )}
        </Transition>
      </div>
    )
  },
)
